import { useState, useEffect } from 'react';

export const usePagination = (data, itemsPerPage = 8) => {
    const [currentPage, setCurrentPage] = useState(1);

    // Calcul du nombre de pages
    const count = Math.ceil(data.length / itemsPerPage);

    // Reset à la page 1 si la longueur des données change (ex: lors d'une recherche)
    useEffect(() => {
        setCurrentPage(1);
    }, [data.length]);

    // Fonction qui retourne uniquement les éléments de la page active
    const currentData = () => {
        const begin = (currentPage - 1) * itemsPerPage;
        const end = begin + itemsPerPage;
        return data.slice(begin, end);
    };

    // Fonction pour changer de page
    const handleChange = (page) => {
        setCurrentPage(page);
    };

    return { 
        next: handleChange, 
        currentData, 
        currentPage, 
        count, 
        totalItems: data.length 
    };
};